import React, { useEffect, useState } from 'react';
import signoutIcon from './images/signout-icon.png'
// import userIcon from './images/user-icon.png'
import editPassword from './images/editPassword.png'
import messagePng from './images/tongzhi.png'
import IconText from "../../iconText/IconText";
import { FormattedMessage } from "react-intl";
import './User.css'
import { connect } from 'react-redux';
import { signOut } from '../../../redux/user/userAction';
import httpRequest from '../../../utils/HttpRequest';
import { urls } from '../../../config/url';
import { Button, Drawer, Menu, message, Dropdown, Tooltip, Input, Modal } from 'antd';
import axios from 'axios';
import store from "../../../redux/store";
import source from './images/source.png'

import userIcon from './images/newuse.png'
import shezhi from './images/shezhi.png'


const classNames = require('classnames');

function User(props: {
    className?: string,
    userName: string,
    signOut: () => void
}) {
    const [apply, setApply] = useState(false);
    // 修改密码是否展示页面
    const [showPassword, setShowPassword] = useState<boolean>(false)
    const [oldPassword, setOldPassword] = useState<string>('')
    const [newPassword, setNewPassword] = useState<string>('')
    const [requirePassword, setRequirPassword] = useState<string>('')

    const [oldRequire, setOldRequire] = useState(false)
    const [newRequire, setNewRequire] = useState(false)
    const [confirmRequire, setConfirmRequire] = useState(false)


    const [titleText, setTitleText] = useState<string>('')

    const [alarmvMessage, setAlarmvalueMessage] = useState(false)
    const [alarmvalue, setAlarmvalue] = useState('')

    const [userSource, setUserSource] = useState(false)
    const [userData, setUserData] = useState<any>()
    useEffect(() => {
        httpRequest(urls.userstatus, {
        }).then(response => {
            const data = response.data;
            if (data.data === 1) {
                setApply(true);
            } else {
            }
        })
        remainMessage()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleOk = () => {
        if (oldPassword == '') {
            setOldRequire(true)
            return
        } else {
            setOldRequire(false)
        }
        if (/\d/.test(newPassword) && /[A-Za-z]/.test(newPassword) && /^[\s\S]{8,28}$/.test(newPassword)) {
            setNewRequire(false)
        } else {
            setNewRequire(true)
            return
        }
        if (newPassword == requirePassword) {
            setConfirmRequire(false)
        } else {
            setConfirmRequire(true)
            return
        }
        httpRequest(urls.modifypasswd, Object.assign({}, {
            USER_PASSWD: oldPassword,
            USER_NEWPASSNWD: newPassword
        }))
            .then(res => {
                if (res.data.errno == 0) {
                    message.success(res.data.errmsg)
                    setShowPassword(false);
                } else {
                    message.error(res.data.errmsg)
                }


            })

    };

    const handleCancel = () => {
        setShowPassword(false);
    };
    useEffect(() => {
        let str = apply ? '' : '(审核中)'
        let str1 = props.userName + str
        console.log(str1);
        setTitleText(str1)

    }, [apply])


    const remainMessage = () => {
        axios({
            method: 'put',
            url: urls.remaincalccoins,
            headers: { 'Authorization': 'Bearer ' + store.getState().user.token },
            data: {},
        }).then(res => {
            if (res.data.data.remain < res.data.data.alarmvalue) {
                setAlarmvalueMessage(true)
                let mes = '国勘币剩余' + res.data.data.remain + ',请及时充值'
                setAlarmvalue(mes)
            }


        }).catch(err => {
            console.log(err);
        })

    }
    const cancel = () => {
        setUserSource(false);
    };

    const handleok = () => {
        setUserSource(false);
    };

    useEffect(() => {
        if (userSource == false) return;
        axios({
            method: 'get',
            url: urls.userstoretimeres,
            headers: { 'Authorization': 'Bearer ' + store.getState().user.token },
            data: {},
        }).then(res => {
            console.log(res.data.data);
            setUserData(res.data.data)
        }).catch(err => {
            console.log(err);
        })
    }, [userSource])

    const settingMenu = (
        <Menu>
            <Menu.Item key="user-resource" onClick={() => { setUserSource(true) }}>用户资源</Menu.Item>
            <Menu.Item key="change-pwd" onClick={() => { setShowPassword(true) }}>修改密码</Menu.Item>
            <Menu.Item key="logout" onClick={props.signOut}>退出登录</Menu.Item>
        </Menu>
    );

    return (
        <div style={{ display: 'flex', alignItems: 'center', marginRight: 50 }}>
            <IconText className="" src={userIcon} >
                <Tooltip title={titleText} placement="topLeft">
                    <span style={{ color: '#fff', marginLeft: '-8px' }}>{props.userName}</span>
                    {/* <span color='red'>{apply ? '' : '(审核中)'}</span> */}
                </Tooltip>

            </IconText>
            <div style={{ marginLeft: 15 }}>
                <Dropdown overlay={settingMenu} placement="bottomLeft">
                    {/* 添加 cursor: pointer 让鼠标悬浮时显示手型，提示可点击 */}
                    <img src={shezhi} style={{ height: 20, cursor: 'pointer' }} />
                </Dropdown>
            </div>

            <div style={{ marginLeft: 15 }}>
                {
                    alarmvMessage === true ? <IconText
                        className=" sign-out"
                        src={messagePng}

                        onClick={() => {
                            setShowPassword(true)
                        }}
                    >
                        <Tooltip placement="topLeft" title={alarmvalue} color='red' key='red'>
                            <span style={{ color: '#fff' }}>通知</span>
                        </Tooltip>


                    </IconText> : ''
                }
            </div>






            {/* <Drawer title="修改密码" placement="right" onClose={handleCancel} visible={showPassword} width={450}>
                <ul style={{ marginTop: 30 }}>
                    <li style={{ height: 62, marginLeft: 20 }}>
                        <span>旧密码：</span>
                        <Input.Password placeholder="旧密码" style={{ width: 180 }} onChange={(e) => {
                            setOldPassword(e.target.value)
                        }} onBlur={(e) => {
                            let passStr = e.target.value
                            if (/\d/.test(passStr) && /[A-Za-z]/.test(passStr) && /^[\s\S]{8,28}$/.test(passStr)) {
                                setOldRequire(false)
                            } else {
                                setOldRequire(true)
                            }
                        }} /><br />
                        <span style={{ color: 'red', fontSize: 10, }}>{oldRequire == true ? '旧密码必须包含数字、字母且长度为8至28个字符' : ''}</span>
                    </li>
                    <li style={{ height: 62, marginLeft: 20 }}>
                        <span>新密码：</span>
                        <Input.Password placeholder="新密码" style={{ width: 180 }} onChange={(e) => {
                            setNewPassword(e.target.value)
                        }} onBlur={(e) => {
                            let passStr = e.target.value
                            if (/\d/.test(passStr) && /[A-Za-z]/.test(passStr) && /^[\s\S]{8,28}$/.test(passStr)) {
                                setNewRequire(false)
                            } else {
                                setNewRequire(true)
                            }
                        }} />
                        <br />
                        <span style={{ color: 'red', fontSize: 10, }}>{newRequire == true ? '密码必须包含数字、字母且长度为8至28个字符!' : ''}</span>
                    </li>
                    <li style={{ height: 62, marginLeft: 5 }}>
                        <span>确认密码：</span>
                        <Input.Password placeholder="确认密码" style={{ width: 180 }} onChange={(e) => {
                            setRequirPassword(e.target.value)
                        }} onBlur={(e) => {

                            if (e.target.value != newPassword) {
                                setConfirmRequire(true)
                            } else {
                                setConfirmRequire(false)
                            }
                        }} />
                        <br />
                        <span style={{ color: 'red', fontSize: 10, marginLeft: 20 }}>{confirmRequire == true ? '确认密码必须跟密码一致!' : ''}</span>
                    </li>
                </ul>
                <Button onClick={handleOk} type='primary' style={{ marginLeft: 110 }}>确定</Button>
                <Button onClick={handleCancel} style={{ marginLeft: 20 }}>取消</Button>
            </Drawer> */}


            <Modal
                title="修改密码"
                open={showPassword}
                onOk={handleOk}
                onCancel={handleCancel}
                className='gradient-title-modal'
                footer={[
                    <>
                        <Button onClick={handleOk} type='primary' style={{}}>确定</Button>
                        <Button onClick={handleCancel} style={{ marginLeft: 20 }}>取消</Button>
                    </>,
                ]}
            >
                <ul style={{ marginTop: 30, listStyleType: 'none', marginLeft: 50 }}>
                    <li style={{ height: 62, marginLeft: 20 }}>
                        <span>旧密码：</span>
                        <Input.Password placeholder="旧密码" style={{ width: 180 }} onChange={(e) => {
                            setOldPassword(e.target.value)
                        }} onBlur={(e) => {
                            let passStr = e.target.value
                            if (/\d/.test(passStr) && /[A-Za-z]/.test(passStr) && /^[\s\S]{8,28}$/.test(passStr)) {
                                setOldRequire(false)
                            } else {
                                setOldRequire(true)
                            }
                        }} /><br />
                        <span style={{ color: 'red', fontSize: 10, }}>{oldRequire == true ? '旧密码必须包含数字、字母且长度为8至28个字符' : ''}</span>
                    </li>
                    <li style={{ height: 62, marginLeft: 20 }}>
                        <span>新密码：</span>
                        <Input.Password placeholder="新密码" style={{ width: 180 }} onChange={(e) => {
                            setNewPassword(e.target.value)
                        }} onBlur={(e) => {
                            let passStr = e.target.value
                            if (/\d/.test(passStr) && /[A-Za-z]/.test(passStr) && /^[\s\S]{8,28}$/.test(passStr)) {
                                setNewRequire(false)
                            } else {
                                setNewRequire(true)
                            }
                        }} />
                        <br />
                        <span style={{ color: 'red', fontSize: 10, }}>{newRequire == true ? '密码必须包含数字、字母且长度为8至28个字符!' : ''}</span>
                    </li>
                    <li style={{ height: 62, marginLeft: 5 }}>
                        <span>确认密码：</span>
                        <Input.Password placeholder="确认密码" style={{ width: 180 }} onChange={(e) => {
                            setRequirPassword(e.target.value)
                        }} onBlur={(e) => {

                            if (e.target.value != newPassword) {
                                setConfirmRequire(true)
                            } else {
                                setConfirmRequire(false)
                            }
                        }} />
                        <br />
                        <span style={{ color: 'red', fontSize: 10, marginLeft: 20 }}>{confirmRequire == true ? '确认密码必须跟密码一致!' : ''}</span>
                    </li>
                </ul>

            </Modal>









            <Modal
                title="用户资源"
                open={userSource}
                onOk={handleOk}
                onCancel={handleCancel}
                className='gradient-title-modal'
                footer={[
                    <>
                        <Button onClick={handleok} type='primary' >确定</Button>
                        <Button onClick={cancel} style={{ marginLeft: 20 }}>取消</Button>
                    </>,
                ]}>
                <ul style={{ marginTop: 30, listStyle: 'none', marginLeft: 50 }}>

                    <li style={{ height: 62, marginLeft: 60, fontSize: 16, fontWeight: 'normal' }}>
                        原始数据：{userData === undefined ? '' : userData.rawsize}
                    </li>
                    <li style={{ height: 62, marginLeft: 60, fontSize: 16, fontWeight: 'normal' }}>
                        成果数据：{userData === undefined ? '' : userData.resultsize}
                    </li>
                    <li style={{ height: 62, marginLeft: 60, fontSize: 16, fontWeight: 'normal' }}>
                        缓存数据：{userData === undefined ? '' : userData.cachesize}
                    </li>
                    <li style={{ height: 62, marginLeft: 44, fontSize: 16, fontWeight: 'normal' }}>
                        已购国勘币：{userData === undefined ? '' : userData.buytimes}
                    </li>
                    <li style={{ height: 62, marginLeft: 44, fontSize: 16, fontWeight: 'normal' }}>
                        已用国勘币：{userData === undefined ? '' : userData.usedtimes}
                    </li>
                    <li style={{ height: 62, marginLeft: 44, fontSize: 16, fontWeight: 'normal' }}>
                        剩余国勘币：{userData === undefined ? '' : (userData.buytimes - userData.usedtimes)}
                    </li>
                </ul>
            </Modal>



{/* 
            <Drawer title="用户资源" placement="right" onClose={cancel} visible={userSource} width={450}>
                <ul style={{ marginTop: 30, listStyle: 'none' }}>

                    <li style={{ height: 62, marginLeft: 60, fontSize: 16, fontWeight: 'normal' }}>
                        原始数据：{userData === undefined ? '' : userData.rawsize}
                    </li>
                    <li style={{ height: 62, marginLeft: 60, fontSize: 16, fontWeight: 'normal' }}>
                        成果数据：{userData === undefined ? '' : userData.resultsize}
                    </li>
                    <li style={{ height: 62, marginLeft: 60, fontSize: 16, fontWeight: 'normal' }}>
                        缓存数据：{userData === undefined ? '' : userData.cachesize}
                    </li>
                    <li style={{ height: 62, marginLeft: 44, fontSize: 16, fontWeight: 'normal' }}>
                        已购国勘币：{userData === undefined ? '' : userData.buytimes}
                    </li>
                    <li style={{ height: 62, marginLeft: 44, fontSize: 16, fontWeight: 'normal' }}>
                        已用国勘币：{userData === undefined ? '' : userData.usedtimes}
                    </li>
                    <li style={{ height: 62, marginLeft: 44, fontSize: 16, fontWeight: 'normal' }}>
                        剩余国勘币：{userData === undefined ? '' : (userData.buytimes - userData.usedtimes)}
                    </li>
                </ul>
                <Button onClick={handleok} type='primary' style={{ marginLeft: 120 }}>确定</Button>
                <Button onClick={cancel} style={{ marginLeft: 20 }}>取消</Button>
            </Drawer> */}















            {/* <div className={classNames("row user", props.className)}>

                <div>
                    <IconText className="" src={userIcon} >
                        <Tooltip title={titleText} placement="topLeft">
                            <span>{props.userName}</span>
                            <span color='red'>{apply ? '' : '(审核中)'}</span>
                        </Tooltip>

                    </IconText>
                    <IconText
                        className=" sign-out"
                        src={signoutIcon}
                        onClick={props.signOut}
                    >
                        <FormattedMessage id="sign_out" defaultMessage="Sign out" description="Sign out" />
                    </IconText>
                </div>
                <div>
                    <IconText
                        className=" sign-out"
                        src={editPassword}

                        onClick={() => {
                            setShowPassword(true)
                        }}
                    >
                        <span>修改密码</span>

                    </IconText>
                    <IconText
                        className=" sign-out"
                        src={source}
                        onClick={() => {
                            setUserSource(true)
                        }}
                    >
                        <span>用户资源</span>

                    </IconText>
                    {
                        alarmvMessage === true ? <IconText
                            className=" sign-out"
                            src={messagePng}

                            onClick={() => {
                                setShowPassword(true)
                            }}
                        >
                            <Tooltip placement="topLeft" title={alarmvalue} color='red' key='red'>
                                <span>通知</span>
                            </Tooltip>


                        </IconText> : ''
                    }




                </div>

            </div> */}















































        </div>

    )
}

const mapStateToProps = (state: {
    user: { userName: string }
}) => {
    return {
        userName: state.user.userName,
    };
};

export default connect(
    mapStateToProps,
    { signOut }
)(User);